"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _layout = require("../../../layout");

var _text = require("../../../text");

var _utils = require("../../../utils");

var _DateInputWithPopup = _interopRequireDefault(require("../DateInputWithPopup"));

var _helperComponents = require("../helperComponents");

var _interfaces = require("../interfaces");

var _utils2 = require("../utils");

var _DatePickerPopupContent = require("./DatePickerPopupContent");

var _PopupDatePickerContext = require("./PopupDatePickerContext");

var _utils3 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["calendarButtonAltText", "clearButtonAltText", "collapsedCloseButtonAltText", "collapsedTitleText", "datePickerProps", "disabled", "flexDirection", "popoverProps", "showSelectedDaysText", "selectedDays", "selectedDaysTotalId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DatePickerGroup = function DatePickerGroup(_ref) {
  var handleChange = _ref.handleChange,
      handleError = _ref.handleError,
      htmlFor = _ref.htmlFor,
      inputProps = _ref.inputProps,
      inputRole = _ref.inputRole,
      inputFooter = _ref.inputFooter,
      inputRef = _ref.inputRef,
      labelText = _ref.labelText,
      name = _ref.name,
      value = _ref.value;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shouldFocusWithValue = _useState2[0],
      setShouldFocusWithValue = _useState2[1];

  var _usePopupDatePickerCo = (0, _PopupDatePickerContext.usePopupDatePickerContext)(),
      calendarButtonAltText = _usePopupDatePickerCo.calendarButtonAltText,
      clearButtonAltText = _usePopupDatePickerCo.clearButtonAltText,
      collapsedCloseButtonAltText = _usePopupDatePickerCo.collapsedCloseButtonAltText,
      collapsedTitleText = _usePopupDatePickerCo.collapsedTitleText,
      datePickerProps = _usePopupDatePickerCo.datePickerProps,
      disabled = _usePopupDatePickerCo.disabled,
      flexDirection = _usePopupDatePickerCo.flexDirection,
      popoverProps = _usePopupDatePickerCo.popoverProps,
      showSelectedDaysText = _usePopupDatePickerCo.showSelectedDaysText,
      selectedDays = _usePopupDatePickerCo.selectedDays,
      selectedDaysTotalId = _usePopupDatePickerCo.selectedDaysTotalId,
      contextProps = (0, _objectWithoutProperties2.default)(_usePopupDatePickerCo, _excluded);

  var datePickerPopupContentProps = _objectSpread({
    datePickerProps: datePickerProps,
    handleChange: handleChange
  }, contextProps);

  var footerId = "".concat(htmlFor, "-footer");

  var forwardedProps = _objectSpread({
    id: htmlFor,
    name: name,
    value: value,
    width: '100%',
    shouldFocusWithValue: shouldFocusWithValue,
    setShouldFocusWithValue: setShouldFocusWithValue,
    'aria-describedby': !!inputFooter ? footerId : undefined
  }, inputProps);

  var inputAriaDescribdeBy = (0, _utils2.getInputAriaDescribedBy)({
    totalsId: showSelectedDaysText && selectedDays ? selectedDaysTotalId : undefined,
    inputFooterId: forwardedProps['aria-describedby'],
    inputWrapperId: datePickerProps['aria-describedby']
  });
  var labelColor = inputProps.error && !disabled ? _utils.LABEL_ERROR_COLOR : _utils.LABEL_COLOR;
  return (0, _core.jsx)(_layout.Col, {
    flex: flexDirection === 'row' ? 1 : undefined
  }, (0, _core.jsx)(_helperComponents.LabelWrapperCol, null, (0, _core.jsx)(_text.Label, {
    color: labelColor,
    fontSize: "T100",
    htmlFor: htmlFor
  }, labelText), (0, _core.jsx)(_DateInputWithPopup.default, {
    renderPopupContent: function renderPopupContent(close) {
      return (0, _DatePickerPopupContent.renderDatePickerPopupContent)(_objectSpread({
        close: close,
        inputRole: inputRole,
        setShouldFocusWithValue: setShouldFocusWithValue
      }, datePickerPopupContentProps));
    },
    onInputChange: handleChange,
    onInputError: handleError,
    popoverProps: popoverProps,
    inputProps: _objectSpread(_objectSpread({}, forwardedProps), {}, {
      locale: datePickerProps.locale,
      'aria-describedby': inputAriaDescribdeBy
    }),
    inputRef: inputRef,
    calendarButtonAltText: (0, _utils3.getRangePickerAltText)(calendarButtonAltText, inputRole),
    collapsedTitleText: collapsedTitleText,
    collapsedCloseButtonAltText: collapsedCloseButtonAltText,
    clearButtonAltText: clearButtonAltText ? (0, _utils3.getRangePickerAltText)(clearButtonAltText, inputRole) : undefined,
    disabled: disabled,
    dataTestComponent: "StencilPopupDateRangePicker".concat(inputRole === _interfaces.DateInputRole.StartDate ? 'Start' : 'End')
  })), !!inputFooter && (0, _core.jsx)("div", {
    id: footerId
  }, inputFooter));
};

var _default = DatePickerGroup;
exports.default = _default;